<template>
  <div class="my-4 mx-md-5 mx-lg-10 mx-xl-10 pa-2 pt-md-0 px-md-4 maxw-1750">
    <template v-if="!isCatalog && items.length === 0">
      <template v-for="i in 7">
        <v-card :key="i" class="mt-4 py-2">
          <v-skeleton-loader
            :key="i"
            type="list-item"
            class="mx-auto"
          ></v-skeleton-loader>
        </v-card>
      </template>
    </template>

    <template v-if="isCatalog && items.length">
      <ListItem
        v-for="(item, i) in items" :key="i"
        class="w-100 pt-1 pb-1 pl-1 ki--list-item"
        :url="url(item)"
      >
        <template slot="title">
          <div class="inlineFlexMW90">
            <div class="alignItemCenter">
              <v-avatar
                class="mr-2"
                size="32"
              >
              <v-icon
                v-if="item.icon && item.icon.startsWith('mdi-')"
                class="primary white--text"
                v-text="item.icon"
                size="20"
              ></v-icon>
              </v-avatar>
              <v-tooltip
                :key="item.id"
                :disabled="item.tooltip == null"
                transition="fade-transition"
                bottom
              >
                <template class="titleCreation" v-slot:activator="{  on }">
                  <span v-on="on">{{ item.name }}</span>
                </template>
                <span >{{ item.tooltip }}</span>
              </v-tooltip>
              <v-spacer />
              <!-- 'mw-25 col-12 col-sm-auto mt-2 mt-sm-0 pa-0 pl-sm-2', -->
              <div
                v-bind:class="[
                'mw-25 mt-2 mt-sm-0 pa-0 pl-sm-2',
                'd-inline-flex flex-nowrap',
                ($vuetify.breakpoint.mdAndUp ? 'justify-end' : 'justify-space-around ' )
                ]"
              >
                <v-btn
                  width="38"
                  height="38"
                  class="mr-4"
                  icon
                  @click.prevent="$event => share($event, item)"
                >
                  <v-icon color="primary">mdi-share-variant</v-icon>
                </v-btn>

                <v-btn
                  width="38"
                  height="38"
                  icon @click.stop="$event => toggleFav($event, item)"
                >
                  <v-icon
                    color="primary"
                    size="20">
                      {{ isElementInBookmark(item.relAttr) ?
                      'mdi-bookmark' : 'mdi-bookmark-outline' }}
                  </v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </template>
      </ListItem>
    </template>

    <template  v-if="isCatalog && items.length === 0">
      <div class="text__notfound">
        <span v-html="$t('views.globalSearch.requestsItems.notFoundSearchLink', [querySearch])">
        </span>
        <a @click="openFormGeneral">
          {{ $t('views.globalSearch.requestsItems.notFoundSearchLinkclick') }}
        </a>
        <span>
          {{ $t('views.globalSearch.requestsItems.notFoundSearchLinkEnd') }}
        </span>
      </div>
    </template>

    <ShareDialog
      :visible="openDialog"
      @input="openDialog = false"
      :item="sharedItem || {}"
      :positionX="sharedDialogPosition.positionX"
      :positionY="sharedDialogPosition.positionY"
    ></ShareDialog>
  </div>
</template>

<script>
import { ListItem, ShareDialog } from '@/components';
import { STATUS as BOOKMARKS_STATUS, BOOKMARK_TYPES } from '@/store/modules/bookmarks';

const TYPE_REQUEST = 'r';

const ticketTypeToBookmarkType = (type) => {
  switch (type) {
  default:
  case 'R': return BOOKMARK_TYPES.REQUESTS;
  case 'I': return BOOKMARK_TYPES.INCIDENTS;
  }
};

const ticketTypeFromFlags = (item) => {
  if (item.cr_flag === 1) {
    return 'r';
  }
  if (item.in_flag === 1) {
    return 'i';
  }
  return 'r';
};

export default {
  props: {
    updatePathOnSearch: {
      type: Boolean,
      default: () => true,
    },
    loading: Boolean,
    text: String,
    items: {
      type: Array,
      default: () => ([]),
    },
    querySearch: String,
    isCatalog: Boolean,
    isKnowledge: Boolean,
    isRequest: Boolean,
  },
  data: () => ({
    sharedItem: null,
    sharedDialogPosition: {},
    openDialog: false,
    ticketType: 'R',
  }),
  components: {
    ListItem,
    ShareDialog,
  },
  methods: {
    search(filters = {}, page) {
      if (!this.loading) {
        this.$emit('request', {
          type: 'list',
          args: {
            filters,
            page,
          },
        });
        if (this.updatePathOnSearch) {
          let newPath = this.$route.path;
          if (typeof filters.text === 'string') {
            newPath += `?text=${filters.text}`;
          }
          this.$router.push(newPath)
            .catch(() => {}); // ignoring avoided redundant navigation exceptions
        }
      }
    },
    isElementInBookmark(elementId) {
      const type = ticketTypeToBookmarkType(this.ticketType);
      return this.$store.getters['bookmarks/isInBookmark'](type, elementId);
    },
    async toggleFav(evt, item) {
      evt.preventDefault();

      const action = this.isElementInBookmark(item.relAttr) ? 'bookmarks/remove' : 'bookmarks/add';
      try {
        await this.$store.dispatch(action, {
          type: ticketTypeToBookmarkType(this.ticketType),
          element: {
            id: item.relAttr,
            name: item.name,
          },
        });
      } catch (ex) {
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('views.requestCreationView.bookmarksSyncError'),
          icon: 'mdi-times',
          type: 'error',
          timeout: this.$getConst('notifications.timeout'),
        });
      }
    },
    share(evt, item) {
      evt.preventDefault();
      const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;
      const elementUrl = item?.zVisibleInternet === 1 || item?.zVisibleInternet === null
        ? `public/element/${ticketTypeFromFlags(item)}/`
        : `element/${ticketTypeFromFlags(item)}/`;
      const fullShareUrl = `${process.env.VUE_APP_EXTERNAL_URL}${process.env.VUE_APP_BASE_URL_MICS_SSPA}${elementUrl}${item.relAttr}`;

      if (isMobile === true && window.flutter_inappwebview) {
        const args = {
          name: this.$t('components.share.mobile.knowledgeItems'),
          url: fullShareUrl,
          formName: item.name,
        };
        window.flutter_inappwebview.callHandler('shareDataUsingNative', args);
      } else {
        this.openDialog = true;
        this.sharedItem = {
          text: `${this.$t('components.share.subjectBody.knowledge')} ${item.name}`,
          url: fullShareUrl,
          formName: item.name,
        };
        const closestButton = evt.target.closest('button');
        const boundingRect = closestButton.getBoundingClientRect();

        this.sharedDialogPosition = {
          positionX: boundingRect.left + (closestButton.offsetWidth / 2),
          positionY: boundingRect.top + (closestButton.offsetHeight / 2),
        };
      }
    },
    url(item) {
      const getPathName = (path = '') => (path.startsWith('/') ? path.split('/')[1] : path);
      return getPathName(`element/${ticketTypeFromFlags(item)}/${item.relAttr}`);
    },
    openFormGeneral() {
      this.$router.push({
        name: 'formGeneric',
        path: `/element/r/${ process.env.VUE_APP_GENERAL_FORM }`,
        params: {
          isPermision: true,
          element: process.env.VUE_APP_GENERAL_FORM,
          type: TYPE_REQUEST,
        },
      });
    },
  },
  computed: {
    filters() {
      const { text } = this;
      return { text };
    },
  },
  mounted() {
    this.search(this.filters, 0);
  },
  async created() {
    const bookmarkType = ticketTypeToBookmarkType(this.ticketType);
    const bookmarkTypeStatus = this.$store.getters['bookmarks/status'](bookmarkType);
    // if bookmarks[type] are not loaded yet we will request them
    if (![BOOKMARKS_STATUS.SUCCESS, BOOKMARKS_STATUS.LOADING].includes(bookmarkTypeStatus)) {
      this.$store.dispatch('bookmarks/get', { type: bookmarkType });
    }
  },
};
</script>

<style lang="scss">
  .ki--list-item > .v-card__title {
    word-break: break-word;
  }
  .text__notfound {
    margin-top: 16px !important;
  }
  .inlineFlexMW90{
      display: inline-flex;
      width: 100%;
  }
  .alignItemCenter{
    display: flex;
    align-items: center !important;
    width: 100%;
  }
  .titleCreation{
    width: calc(100% - 40px) !important;
    font-size: 0.95rem !important;
    // min-width: 70%;
  }

  @media screen and (max-width: 600px) {
    .titleSolutions{
    width: calc(100% - 40px) !important;
    font-size: 0.85rem !important;
    }
    .titleCreation{
    width: calc(100% - 40px) !important;
    font-size: 0.85rem !important;
    // min-width: 70%;
    }
  }

  @media (min-width: 600px) {
    .ki--list-item > .v-card__title {
      flex-wrap: nowrap;
    }
    .mobileView{
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }
</style>
